var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "header" }, [_vm._v("Add a response")]),
    _vm._v(" "),
    _c(
      "form",
      {
        ref: "form",
        staticClass: "form response-form",
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.onSubmit.apply(null, arguments)
          },
        },
      },
      [
        _c("fieldset", { staticClass: "form__group" }, [
          _c("div", { staticClass: "toggle-group" }, [
            _vm.formData.ableToHelp === null
              ? _c("img", {
                  staticClass: "avatar avatar--small",
                  attrs: { src: `/images/avatar/${_vm.user.id}`, alt: "" },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.ableToHelp,
                  expression: "formData.ableToHelp",
                },
              ],
              staticClass: "toggle",
              attrs: {
                id: "able-to-help",
                name: "able-to-help",
                type: "radio",
              },
              domProps: {
                value: true,
                checked: _vm._q(_vm.formData.ableToHelp, true),
              },
              on: {
                change: function ($event) {
                  return _vm.$set(_vm.formData, "ableToHelp", true)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "toggle", attrs: { for: "able-to-help" } },
              [_vm._v("I can help")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.formData.ableToHelp,
                  expression: "formData.ableToHelp",
                },
              ],
              staticClass: "toggle",
              attrs: {
                id: "unable-to-help",
                name: "able-to-help",
                type: "radio",
              },
              domProps: {
                value: false,
                checked: _vm._q(_vm.formData.ableToHelp, false),
              },
              on: {
                change: function ($event) {
                  return _vm.$set(_vm.formData, "ableToHelp", false)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              { staticClass: "toggle", attrs: { for: "unable-to-help" } },
              [_vm._v("Sorry, I cannot help")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.formData.ableToHelp !== null
          ? _c("div", { staticClass: "reply" }, [
              _c("div", { staticClass: "reply__buttons" }, [
                _c("img", {
                  staticClass: "avatar avatar--small",
                  attrs: { src: `/images/avatar/${_vm.user.id}`, alt: "" },
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.hasAttachments,
                      expression: "formData.hasAttachments",
                    },
                  ],
                  staticClass: "toggle",
                  attrs: {
                    id: "has-attachments",
                    name: "has-attachments",
                    type: "checkbox",
                  },
                  domProps: {
                    value: true,
                    checked: Array.isArray(_vm.formData.hasAttachments)
                      ? _vm._i(_vm.formData.hasAttachments, true) > -1
                      : _vm.formData.hasAttachments,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.formData.hasAttachments,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = true,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.formData,
                              "hasAttachments",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.formData,
                              "hasAttachments",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.formData, "hasAttachments", $$c)
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { attrs: { for: "has-attachments" } },
                  [
                    _c("SvgIcon", { attrs: { icon: "link" } }),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("Add Attachment"),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("fieldset", { staticClass: "reply__fields" }, [
                _c("div", { staticClass: "form__group" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.content,
                        expression: "formData.content",
                      },
                    ],
                    staticClass: "form__control",
                    attrs: { placeholder: "Enter your response here..." },
                    domProps: { value: _vm.formData.content },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(_vm.formData, "content", $event.target.value)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.formData.hasAttachments,
                        expression: "formData.hasAttachments",
                      },
                    ],
                    staticClass: "form__group",
                  },
                  [
                    _c("FileUpload", {
                      attrs: {
                        id: "documents",
                        name: "documents",
                        multiple: true,
                      },
                      model: {
                        value: _vm.formData.documents,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "documents", $$v)
                        },
                        expression: "formData.documents",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._m(0),
              ]),
            ])
          : _c(
              "div",
              {
                ref: "bar",
                staticClass: "form__group form__group--submit-fixed",
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "btn",
                    attrs: { for: "able-to-help" },
                    on: { click: _vm.scrollToForm },
                  },
                  [_vm._v("I can help")]
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "btn",
                    attrs: { for: "unable-to-help" },
                    on: { click: _vm.scrollToForm },
                  },
                  [_vm._v("Sorry, I cannot help")]
                ),
              ]
            ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form__group" }, [
      _c("button", { staticClass: "btn btn--primary" }, [_vm._v("Save")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }